import { KreezeeSession } from '../../../../models/account/kreezeeSession';
import { Culture } from '../../../../models/account/culture';
import { getKreezeeSession, getLanguage, setLanguage } from '../../../../utilities/LocalStorage';

const EN = 'en';
const FR = 'fr';

export function getDefaultCulture(): Culture {
  let culture: Culture = EN;
  const kreezeeSession: KreezeeSession | null = getKreezeeSession(); //session
  const localLanguage: Culture | null = getLanguage(); //localstorage
  const browserCulture: string = window.navigator.language; //browser

  const params: URLSearchParams = new URLSearchParams(window.location.search);
  const urlLang: string | null = params.get('lang');

  if (kreezeeSession && kreezeeSession.culture) {
    //1. Check kreezeeSession
    culture = kreezeeSession.culture;
  } else if (urlLang === FR || urlLang === EN) {
    //2. Check url params
    culture = urlLang;
  } else if (localLanguage) {
    //3. Check local storage
    culture = localLanguage;
  } else if (browserCulture === FR || browserCulture.includes(FR + '-')) {
    //4. Check browser
    culture = FR;
  }

  setLanguage(culture);

  return culture;
}
